




















import GuestAnonInfo from '~/components/car/classifieds/view/partials/seller/guest-anon/GuestAnonInfo.vue'
import BlacklistedSellerAlert from '~/components/car/classifieds/view/BlacklistedSellerAlert.vue'
import { mapGetters } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import UserProfileLink from '~/components/car/user/UserProfileLink.vue'
import { resolveCategory } from '~/utils/category'
import { CategoryId } from '~/models/category/types'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    BlacklistedSellerAlert,
    GuestAnonInfo,
    UserProfileLink
  },
  props: {
    classified: {
      type: Object,
      required: true
    },
    seller: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      sellerIsBlacklistedSuspiciousOrFraudster:
        'sellerIsBlacklistedSuspiciousOrFraudster',
      sellerOnlyContactViaMessages: 'sellerOnlyContactViaMessages'
    }),
    showDownpaymentAlert() {
      if (this.classified?.category_ids) {
        return resolveCategory(
          {
            [CategoryId.JOBS]: false,
            [CategoryId.CLASSIFIEDS]: true
          },
          this.classified.category_ids
        )
      }
      return false
    }
  }
})
